<div
  class="splash-screen"
  [class.splash-screen--hidden]="!(splashScreenService.showSplashScreen$ | async)"
  [attr.inert]="(splashScreenService.showSplashScreen$ | async) ? '' : null"
  [attr.aria-hidden]="!(splashScreenService.showSplashScreen$ | async)"
  [attr.aria-busy]="(splashScreenService.showSplashScreen$ | async) ? 'true' : null">
  @if (!logoFailed) {
  <img
    src="/assets/icons/splash-logo-mark.png"
    alt="DUNA Logo"
    class="logo"
    (error)="onLogoError($event)">
  } @else {
  <div class="logo logo--text" aria-hidden="true">DUNA</div>
  }
  <div class="splash-loader" role="progressbar" aria-label="Indlæser">
    <div class="splash-loader__track">
      <div class="splash-loader__bar"></div>
    </div>
  </div>
</div>
